import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  makeStyles,
  MenuItem,
  TableCell,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ReplyIcon from "@material-ui/icons/Reply";
import { dateFormated } from "../../functionalComponents/dataFormatFunctions";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ChevronRight } from "@material-ui/icons";
import PONegotiationDialogBox from "./PONegotiationDialogBox";
import { useDispatch } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import { fetchSLFromPODashboard } from "../../../../containers/actions/common/purchaseOrderAction";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { appUrl } from "../../../../../../utils/config";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import StyledButton from "../../models/Button";
import CancelIcon from "@material-ui/icons/Cancel";
import BackDropLoading from "../../models/BackDrop";

const useStyles = makeStyles((theme) => ({
  responseBtn: {
    cursor: "pointer",
    fontSize: "large",
    //     '&:hover': {
    //         fontSize: 'medium',
    // },
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "80px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  dialogPaper: {
    borderRadius: "1rem",
  },
}));

const EditSponsorPOColumns = (props) => {
  const { row, handleRefresh, featuresAccess, showPencilIcon } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  // const originalPO = useRef(row);
  const [successDialogBox, setSuccessDialogBox] = useState({
    openDialogBox: false,
    dialogBoxType: "",
  });
  const [saveFailed, setSaveFailed] = useState(false);
  const [negotiation, setNegotiation] = useState(false);
  const [rejectOpen, setRejectOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [reasonCodes, setReasonCodes] = useState([]);
  // BCM-791: which value ("qty" | "date") the currently open edit popup targets
  const [negotiationValueType, setNegotiationValueType] = useState("qty");
  // BCM-791: which value the reject dialog targets
  const [rejectValueType, setRejectValueType] = useState("qty");
  // BCM-791: which value the last accept/reject acted on (drives the toast wording)
  const [actionValueType, setActionValueType] = useState("qty");
  const actionLabel = actionValueType === "date" ? "Date" : "Qty";
  const rejectLabel = rejectValueType === "date" ? "Date" : "Qty";
  const { roleName, organizationName, authToken } = localStorage;
  var token = authToken;
  var decoded = jwt_decode(token);

  // console.log(row, 'row')

  const handleNegotiation = (type) => {
    setNegotiation(false);
    if (type === "success") {
      setSuccessDialogBox({
        openDialogBox: true,
        dialogBoxType: "valueProposed",
      });
    } else if (type === "failed") {
      setSaveFailed(true);
    }
  };

  // BCM-791: open the reject dialog scoped to a single value
  const handleRejectOpen = (vType) => {
    const v = vType === "date" ? "date" : "qty";
    setRejectValueType(v);
    setActionValueType(v);
    setRejectOpen(true);
  };

  // BCM-791: open the edit popup scoped to a single value
  const handleEditOpen = (vType) => {
    setNegotiationValueType(vType === "date" ? "date" : "qty");
    setNegotiation(true);
  };

  // BCM-791: accept a single BMS proposed value (CMO action)
  const handleAccept = (vType) => {
    const v = vType === "date" ? "date" : "qty";
    setActionValueType(v);
    if (row?.scheduleLineDetails?.scheduleLineStatusID == 29) {
      handleSave("revisedOfferAccepted", v);
    } else {
      handleSave("AcceptOffer", v);
    }
  };

  const handleRejectClose = () => {
    setRejectOpen(false);
    setSelectedReason("");
    setComment("");
    setError(false);
  };

  useEffect(() => {
    if (rejectOpen) {
      const requestObject = {
        searchField: "all",
        searchValue: "",
        reasonCodeGroupType: "all",
        reasonCodeType: "all",
        status: "all",
        collaboratorTypeID: "all",
      };
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodesDirect`,
          requestObject
        )
        .then((res) => {
          if (res.data.status) {
            if (
              Array.isArray(res.data?.data?.reasonCodeList) &&
              res.data?.data?.reasonCodeList.length > 0
            ) {
              setReasonCodes(res.data.data.reasonCodeList);
            }
          }
        })
        .catch(() => {});
    }
  }, [rejectOpen]);

  const handleSave = (type, actionVType) => {
    dispatch({
      type: OPEN_BACKDROP,
    });

    const isReject = type === "RejectOffer" || type === "revisedOfferRejected";
    // BCM-791 Approach A: exactly one change flag is set per action (qty XOR date).
    const vType = actionVType === "date" ? "date" : "qty";
    const changeInQty = vType === "qty";
    const changeInDate = vType === "date";
    // BCM-791: separate accept/reject flags per value, set based on which action
    // (accept vs reject) and which value (qty vs date) was clicked
    const qtyAcceptedFlag = !isReject && changeInQty;
    const dateAcceptedFlag = !isReject && changeInDate;
    const qtyRejectedFlag = isReject && changeInQty;
    const dateRejectedFlag = isReject && changeInDate;

    let data;

    if (isReject) {
      data = {
        ecosystemId: localStorage.ecosystemId || 1,
        organizationName: localStorage.organizationName || "",
        roleName: localStorage.roleName || "",
        collabType: 2,
        vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
        schrockenSAID: row?.scheduleLineDetails?.schrockenSAID,
        scheduleAgreementNumber: row?.scheduleLineDetails?.scheduleAgreementNumber,
        scheduleAgreementStatusID: row?.scheduleLineDetails?.scheduleLineStatusID,
        scheduleAgreementStatusText: row?.scheduleLineDetails?.scheduleLineStatusText,
        poApprovedFlag: false,
        poLineEditFlag: true,
        acceptOfferFlag: false,
        rejectOfferFlag: false,
        updateCMORejection: true,
        comments: comment || null,
        SLDetails: {
          reasonCode: selectedReason,
          comments: comment || null,
          schrockenSLID: row?.scheduleLineDetails?.schrockenSLID,
          schrockenSAID: row?.scheduleLineDetails?.schrockenSAID,
          scheduleLineItemNumber: row?.scheduleLineDetails?.scheduleLineItemNumber,
          scheduleLineStatusID: row?.scheduleLineDetails?.scheduleLineStatusID,
          scheduleLineStatusText: row?.scheduleLineDetails?.scheduleLineStatusText,
          targetQuantity: row?.scheduleLineDetails?.targetQuantity,
          deliveryDate: row?.scheduleLineDetails?.deliveryDate,
          committedQuantity: row?.scheduleLineDetails?.committedQuantity,
          committedDeliveryDate: row?.scheduleLineDetails?.committedDeliveryDate,
          sponsorProposedQuantity: row?.scheduleLineDetails?.sponsorProposedQuantity,
          sponsorProposedDeliveryDate: row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
          cmoProposedQuantity: row?.scheduleLineDetails?.cmoProposedQuantity,
          cmoProposedDeliveryDate: row?.scheduleLineDetails?.cmoProposedDeliveryDate,
          vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
          brandOwnerMosymphonyID: row?.scheduleLineDetails?.brandOwnerMosymphonyID,
          // BCM-791: CMO rejects a single BMS proposed value
          changeInQty: changeInQty,
          changeInDate: changeInDate,
          qtyAcceptedFlag: qtyAcceptedFlag,
          dateAcceptedFlag: dateAcceptedFlag,
          qtyRejectedFlag: qtyRejectedFlag,
          dateRejectedFlag: dateRejectedFlag,
          markedForDelete: "false",
          // rejectionNote: rejectionNoteText,
          cmoRejectedSponsorProposal: true,
        },
      };
    } else {
      data = {
        vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
        scheduleAgreementStatusID: row?.scheduleLineDetails?.scheduleLineStatusID,
        scheduleAgreementStatusText:
          row?.scheduleLineDetails?.scheduleLineStatusText,
        schrockenSAID: row?.scheduleLineDetails?.schrockenSAID,
        scheduleAgreementNumber:
          row?.scheduleLineDetails?.scheduleAgreementNumber,
        vendorName: row?.scheduleLineDetails?.vendorName,
        sponsorName: row?.scheduleLineDetails?.sponsorName,
        productsList: row?.scheduleLineDetails
          ? [
              {
                fgMaterialCode: row?.scheduleLineDetails?.fgMaterialCode,
                fgMaterialName: row?.scheduleLineDetails?.fgMaterialName,
              },
            ]
          : [],
        poApprovedFlag: [21, 22, 23].includes(
          row?.scheduleLineDetails?.scheduleLineStatusID
        )
          ? false
          : true,
        poLineEditFlag:
          type === "AcceptOffer" || type === "revisedOfferAccepted"
            ? true
            : false,
        acceptOfferFlag:
          type === "AcceptOffer" || type === "revisedOfferAccepted"
            ? true
            : false,
        rejectOfferFlag: false,
        approveFlag: false,
        shareWithCMOFlag: type === "sharedWithCMO" ? true : false,
        confirmedFlag: false,
        SLDetails: {
          ...row?.scheduleLineDetails,
          reasonCode: selectedReason,
          comments: comment,
          // BCM-791: CMO accepts a single BMS proposed value
          changeInQty: changeInQty,
          changeInDate: changeInDate,
          qtyAcceptedFlag: qtyAcceptedFlag,
          dateAcceptedFlag: dateAcceptedFlag,
          qtyRejectedFlag: qtyRejectedFlag,
          dateRejectedFlag: dateRejectedFlag,
          markedForDelete: false,
        },
      };
    }
 
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updatePODetailsNew`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setSuccessDialogBox({
            openDialogBox: true,
            dialogBoxType: type,
          });
        } else {
          setSaveFailed(true);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        setSaveFailed(true);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        // console.log(err);
      });

    // setTimeout(() => {
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });
    //   setSuccessDialogBox({
    //     openDialogBox: true,
    //     dialogBoxType: type,
    //   });
    // }, 3000);
  };

  // BCM-791: renders the pencil (Sponsor edit) + accept/reject (CMO) controls for a
  // SINGLE value. Presence of the accept/reject controls is gated on that value alone
  // (qty controls need a proposed qty, date controls need a proposed date) — no longer
  // on both being present.
  const renderProposedControls = (vType) => {
    const hideControls =
      row?.scheduleLineDetails?.scheduleLineStatusID === 30 ||
      [9].includes(row?.batchDetails?.batchStatusID);
    if (hideControls) return null;
    const hasValue =
      vType === "qty"
        ? row?.scheduleLineDetails?.sponsorProposedQuantity != null
        : !!row?.scheduleLineDetails?.sponsorProposedDeliveryDate;
    return (
      <Box style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
        {localStorage.collabType !== "CMO" &&
          featuresAccess?.editSponsorProposedValues &&
          props.showPencilIcon && (
            <span title="Edit">
              <EditIcon
                fontSize="large"
                style={{ color: "#ec6535", cursor: "pointer" }}
                onClick={() => handleEditOpen(vType)}
              />
            </span>
          )}
        {localStorage.collabType === "CMO" &&
          hasValue &&
          featuresAccess?.acceptOffer && (
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span title="Accept">
                <CheckCircleIcon
                  fontSize="medium"
                  style={{
                    backgroundColor: "white",
                    color: "green",
                    fontWeight: "bold",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  onClick={() => handleAccept(vType)}
                />
              </span>
              {featuresAccess?.rejectOffer === true && (
                <span title="Reject">
                  <CancelIcon
                    onClick={() => handleRejectOpen(vType)}
                    style={{
                      color: "red",
                      fontSize: "25px",
                      cursor: "pointer",
                    }}
                  />
                </span>
              )}
            </span>
           )} 
      </Box>
    );
  };

  return (
    <React.Fragment>
      <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "flex-end",
          }}
        >
          {row?.scheduleLineDetails?.sponsorProposedQuantity != null
            ? row?.scheduleLineDetails?.sponsorProposedQuantity
            : ""}
          {renderProposedControls("qty")}
        </Box>
      </TableCell>

      <TableCell style={{ whiteSpace: "nowrap" }}>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "left",
          }}
        >
          {dateFormated(
            row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
            "DD-MMM-YYYY",
            ""
          )}
          {renderProposedControls("date")}
        </Box>
      </TableCell>

      <Dialog open={rejectOpen} maxWidth="md" fullWidth>
        <BackDropLoading />
        <DialogContent>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleRejectClose}
            >
              Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
            </Typography>
          </Grid>
          <Typography
            style={{
              fontWeight: "500",
              color: "black",
              fontSize: "2rem",
              margin: "1rem",
              textAlign: "center",
            }}
          >
            Reject BMS Proposed {rejectLabel} for PO{" "}
            {row?.scheduleLineDetails?.scheduleAgreementNumber}
          </Typography>
          <Grid
            container
            spacing={0}
            style={{
              marginTop: "1rem",
              display: "flex",
              // alignItems: "center",
              // justifyContent: "space-between",
            }}
          >
            {/* BCM-791: qty reject shows BMS Proposed Qty + UOM only (date field removed) */}
            {rejectValueType === "qty" && (
              <Grid item xs={3} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  BMS Proposed Qty.
                </Typography>
                <Typography>
                  {row?.scheduleLineDetails?.sponsorProposedQuantity || ""}
                </Typography>
              </Grid>
            )}
            {rejectValueType === "qty" && (
              <Grid item xs={3} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  UOM
                </Typography>
                <Typography>
                  {row?.scheduleLineDetails?.targetQuantityUOM || ""}
                </Typography>
              </Grid>
            )}
            {/* BCM-791: date reject shows BMS Proposed Date only (qty + UOM removed) */}
            {rejectValueType === "date" && (
              <Grid item xs={3} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  BMS Proposed Date
                </Typography>
                <Typography>
                  {dateFormated(
                    row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
                    "DD-MMM-YYYY",
                    ""
                  )}
                </Typography>
              </Grid>
            )}
          </Grid>

          <Grid container spacing={3} style={{ marginTop: "1rem" }}>
            <Grid item xs={4}>
              <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
                Reason Code / Description
              </Typography>
              <TextField
                select
                fullWidth
                value={selectedReason}
                onChange={(e) => {
                  setError(false);
                  setSelectedReason(e.target.value);
                }}
                variant="outlined"
                size="small"
                error={error && !selectedReason}
                helperText={
                  error && !selectedReason ? "Select reason code" : ""
                }
                style={{ width: "600px" }}
              >
                <MenuItem value="none" disabled>
                  Select Reason Code / Description
                </MenuItem>
                {reasonCodes.map((reason) => (
                  <MenuItem key={reason.reasonCodeID} value={reason.reasonCode}>
                    {reason.reasonCode} / {reason.reasonDescription || ""}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
                Comment
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                value={comment}
                onChange={(e) => {
                  setError(false);
                  if (e.target.value.length < 256) {
                    setComment(e.target.value);
                  }
                }}
                variant="outlined"
                size="small"
                error={error}
                placeholder="Enter text here"
              />
              <Typography variant="caption" style={{ color: error ? "red" : undefined }}>
                {error
                  ? "Please select a reason code or enter a comment."
                  : "Note - If reason code is not entered, comment field is mandatory."}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 16, justifyContent: "center" }}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<ChevronRight />}
            style={{
              borderRadius: "20px",
              textTransform: "none",
            }}
            onClick={() => {
              const reasonMissing = !selectedReason || selectedReason === "none";
              const commentMissing = !comment.trim();
              const invalid =
                (reasonMissing && commentMissing) ||
                (selectedReason === "EXMRP019" && commentMissing);
              if (invalid) {
                setError(true);
                return;
              }
              const v = rejectValueType;
              handleRejectClose();
              if (row?.scheduleLineDetails?.scheduleLineStatusID == 29) {
                handleSave("revisedOfferRejected", v);
              } else {
                handleSave("RejectOffer", v);
              }
            }}
          >
            Save changes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={successDialogBox.openDialogBox}
        disableBackdropClick // Disable closing on outside click
        disableEscapeKeyDown // Disable closing on escape key
        maxWidth="sm"
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent className={classes.dialogContent}>
          <CheckCircleIcon className={classes.avatar} />
          <Typography
            style={{
              marginTop: "10px",
              fontWeight: "600",
              color: "black",
              fontSize: "1.4rem",
            }}                                                                                                                                                                                                                                                                                                                                                                                                                                                
          >
            {/* BCM-791: value-specific wording (CMO acting on a single BMS proposed value) */}
            {successDialogBox.dialogBoxType === "sharedWithCMO"
              ? "Shared the PO Details with CMO successfully"
              : (successDialogBox.dialogBoxType === "AcceptOffer" ||
                  successDialogBox.dialogBoxType === "revisedOfferAccepted") &&
                localStorage.collabType === "CMO"
              ? `BMS Proposed ${actionLabel} accepted`
              : successDialogBox.dialogBoxType === "valueProposed"
              ? "Updated successfully"
              : successDialogBox.dialogBoxType === "RejectOffer" ||
                successDialogBox.dialogBoxType === "revisedOfferRejected"
              ? `BMS Proposed ${actionLabel} rejected`
              : "Updated successfully"}
          </Typography>
          <DialogActions className={classes.dialogActions}>
            <Button
              variant="contained"
              color="primary"
              endIcon={<ChevronRight />}
              style={{
                borderRadius: "20px",
                textTransform: "none",
              }}
              onClick={() => {
                // PO dashboard API refreshes "Current Values"; SL details fetch
                // refreshes this row's expanded (chevron) view. Both are needed.
                handleRefresh();
                const schrockenSLID = row?.scheduleLineDetails?.schrockenSLID;
                if (schrockenSLID) {
                  dispatch(fetchSLFromPODashboard(schrockenSLID)).catch(() => {});
                }
                setSuccessDialogBox({
                  openDialogBox: false,
                  dialogBoxType: "",
                });
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>

      {negotiation && (
        <PONegotiationDialogBox
          open={negotiation}
          handleClose={handleNegotiation}
          row={row}
          valueType={negotiationValueType}
        />
      )}
    </React.Fragment>
  );
};

export default EditSponsorPOColumns;
